<template>
  <v-container class="pr-0 pl-0" fluid>


    <v-card v-if="(!alunoList || alunoList.length < 1) && finishedLoad" class="elevation-5">
      <v-img width="100%" src="@/assets/images/coach-running.jpg" gradient="to bottom, rgba(0,0,0,.6), rgba(0,0,0,.7)"
        class="align-end">
        <v-card-text class="text-white title text-center">
          Você não tem alunos ainda associados a você. :o)
        </v-card-text>
      </v-img>
    </v-card>

    <v-card class="elevation-5 mb-3 pb-5 pt-5 " v-if="alunoList && alunoList.length > 0">
      <v-list subheader>
        <v-row v-for="(item,index) in alunoList" :key="item.id" class="ml-1 mr-1">
          <v-list-item>
            <v-list-item-avatar>
              <v-img :src="item.profile.media.url"></v-img>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title v-text="item.fullName"></v-list-item-title>
              <v-list-item-subtitle class="caption" v-if="true">nenhum treino registrado</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-icon>
              <v-btn fab dark x-small primary @click="openAlunoDetalhe(item)">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
              <!-- <v-btn fab dark x-small primary>
                <v-icon>mdi-plus</v-icon>
              </v-btn> -->
            </v-list-item-icon>
          </v-list-item>
          <v-list-item class="mt-0 mb-0" v-if="(index + 1) < alunoList.length">
            <v-divider></v-divider>
          </v-list-item>
        </v-row>
      </v-list>
    </v-card>

    <!-- modal com os detalhes  -->
    <v-row justify="center" class="">
      <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition" class="">
        <v-card class="">
          <v-toolbar dark color="primary">
            <v-toolbar-title>{{selectedAluno.fullName}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="pt-2 pl-0 pr-0">
            <v-expansion-panels v-model="panelStatus" class="px-md-16 pt-md-6" :disabled="dialogLoader2">
              <!-- panel com o proximo treino -->
              <v-expansion-panel class="pr-0 pl-0">
                <v-expansion-panel-header class="title primary lighten-3">Programar treino</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card class="elevation-0">
                    <v-card-text>
                      <v-row>
                        <!-- Date Picker -->
                        <v-col cols="12" md="4" sm="12" class="mb-n5">
                          <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y
                            max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field v-model="computedDateFormatted" label="Data do Treino" persistent-hint
                                prepend-icon="mdi-calendar-month-outline" readonly outlined dense v-bind="attrs"
                                v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="dateTreino" no-title @input="menu2 = false" :min="today"
                              color="primary"></v-date-picker>
                          </v-menu>
                        </v-col>

                        <!-- Sports Selection -->
                        <v-col cols="12" md="4" sm="12" class="mb-n5">
                          <v-select v-model="selectedEsporte" :items="esportesList" label="Esporte" item-text="nome"
                            dense clearable outlined prepend-icon="mdi-clipboard-list" class="mb-0"
                            @click:clear="selectedTipoTreino = null" return-object
                            @change="calculatedPace = null"></v-select>
                        </v-col>

                        <!-- Button to Insert Series -->
                        <v-col cols="12" md="4" sm="12" class="mb-5 text-center"
                          v-if="selectedEsporte != null && selectedEsporte.nome != null"
                          transition="slide-x-transition">
                          <v-btn color="primary" v-if="selectedEsporte != null && selectedEsporte.nome != null"
                            :disabled="dialogLoader" width="100%" transition="slide-x-transition"
                            @click="dialogSerie = !dialogSerie">
                            Inserir série
                            <v-icon right>mdi-clipboard-list-outline</v-icon>
                          </v-btn>
                        </v-col>

                        <!-- Series Fields -->
                        <v-col cols="12" v-for="(item, index) in seriesDoTreino" :key="index" class="pl-0 pr-0 pb-0">
                          <treino-text-field :serieTreino="item" :esporte="item.esporte" />
                        </v-col>

                        <!-- Remove Series Button -->
                        <v-col cols="12" v-if="seriesDoTreino && seriesDoTreino.length > 0">
                          <v-btn color="red lighten-2" class="mt-5" width="100%" @click="removerSeries()"
                            :disabled="dialogLoader">
                            Remover Séries
                            <v-icon right>mdi-trash-can-outline</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>

                      <!-- Repeat Until Date -->
                      <v-row v-if="radiosRepetir != null" class="justify-center font-weight-bold">
                        Repetir até {{ computedDateLimiteFormatted }}
                      </v-row>
                    </v-card-text>

                    <v-card-actions>
                      <v-btn color="primary" class="white--text" @click="dialogRepeat = true" width="45%"
                        :disabled="dialogLoader || seriesDoTreino == null || seriesDoTreino.length == 0">
                        Repetir
                        <v-icon right dark>mdi-calendar-sync</v-icon>
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" class="white--text" @click="salvarTreino()" width="45%"
                        :disabled="dialogLoader || seriesDoTreino == null || seriesDoTreino.length == 0">
                        Salvar
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>

                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- panel com os ultimos treinos -->
              <v-expansion-panel class="pr-0 pl-0">
                <v-expansion-panel-header class="title primary lighten-3">Últimos treinos</v-expansion-panel-header>
                <v-expansion-panel-content class="pt-3 pr-0 pl-0">
                  <v-row>
                    <v-col cols="12" md="6" lg="4" xl="3" v-for="item in selectedAlunoTreinosFeitos" :key="item.id"
                      class="">
                      <card-treino v-bind:item="item" />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </v-card>

        <div class="text-center">
          <v-dialog v-model="dialogComment" width="500">
            <v-card>
              <v-card-title class="headline grey lighten-2" primary-title>Comentários do treino</v-card-title>

              <v-card-text class="mt-4">{{loadedComment}}</v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialogComment = false">fechar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>


        <div class="text-center">
          <v-dialog v-model="dialogLoader2" hide-overlay persistent width="300">
            <v-card color="primary" dark>
              <v-card-text class="pt-5">
                Carregando os dados...
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </v-dialog>
    </v-row>

    <!-- dialog para inserir série no treino : -->
    <div width="100%">
      <v-dialog v-model="dialogSerie" transition="fade-transition" class="" max-width="500">
        <v-card v-if="selectedEsporte != null && selectedEsporte.nome != null" class="">
          <v-card-title primary-title class="primary pr-2">
            Série de {{selectedEsporte.nome}}
            <v-spacer></v-spacer>
            <v-btn color="white" icon @click="dialogSerie = !dialogSerie">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="pt-6">
            <v-row>

              <v-col cols="12" class="mb-0 pb-0">
                <v-select v-model="selectedTipoTreino" :items="tipoTreinoList" label="Tipo de Treino" item-text="nome"
                  dense clearable outlined prepend-icon="mdi-clipboard-list" class="mb-0" return-object></v-select>
              </v-col>

              <v-col cols="12" class="pt-0 pb-4">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="6" v-if="selectedTipoTreino != null &&  selectedTipoTreino.nome == 'Pace'" class="pt-0 pb-0">
                <v-select v-model="paceMinutos" v-if="selectedTipoTreino != null &&  selectedTipoTreino.nome == 'Pace'"
                  :items="repeticoes240List" prepend-icon="mdi-timer-outline" outlined dense label="Min"
                  @change="calculatePace"></v-select>
              </v-col>
              <v-col cols="6" v-if="selectedTipoTreino != null &&  selectedTipoTreino.nome == 'Pace'" class="pt-0 pb-0">
                <v-select v-model="paceSegundos" v-if="selectedTipoTreino != null &&  selectedTipoTreino.nome == 'Pace'"
                  :items="repeticoes240List" outlined dense label="Seg" @change="calculatePace"></v-select>
              </v-col>

              <v-col cols="6"
                v-if="(selectedTipoTreino != null &&  selectedTipoTreino.nome == 'Pace') && (selectedEsporte != null && selectedEsporte.nome != 'Natação')"
                class="pt-0 pb-0">
                <v-select v-model="paceKilometros" :items="repeticoes100List" prepend-icon="mdi-road" label="Kms"
                  outlined dense @change="calculatePace"></v-select>
              </v-col>
              <v-col cols="12"
                v-if="(selectedTipoTreino != null &&  selectedTipoTreino.nome == 'Pace') && (selectedEsporte != null && selectedEsporte.nome == 'Natação')"
                class="pt-0 pb-0">
                <v-select v-model="metrosNatacao" :items="metrosNatacaoList" prepend-icon="mdi-map-marker-distance"
                  label="Metros" outlined dense @change="calculatePace"></v-select>
              </v-col>
              <v-col cols="6" v-if="(selectedTipoTreino != null &&  selectedTipoTreino.nome == 'Pace')"
                class="pt-0 pb-0">
                <v-select v-model="paceMetros"
                  v-if="(selectedTipoTreino != null &&  selectedTipoTreino.nome == 'Pace') && (selectedEsporte != null && selectedEsporte.nome != 'Natação')"
                  :items="repeticoes900List" label="Metros" outlined dense @change="calculatePace"></v-select>
              </v-col>

              <!-- adicionado depois, porque treinos de ciclismo por potencia também precisam ter segundos -->
              <v-col cols="6"
                v-if="selectedTipoTreino != null &&  (selectedTipoTreino.nome == 'Potência' || selectedTipoTreino.nome == 'Frequência')"
                class="pt-0 pb-0">
                <v-select v-model="tempo"
                  v-if="selectedTipoTreino != null &&  (selectedTipoTreino.nome == 'Potência' || selectedTipoTreino.nome == 'Frequência')"
                  :items="repeticoes240List" prepend-icon="mdi-timer-outline" outlined dense label="Min"></v-select>
              </v-col>
              <v-col cols="6"
                v-if="selectedTipoTreino != null &&  (selectedTipoTreino.nome == 'Potência' || selectedTipoTreino.nome == 'Frequência')"
                class="pt-0 pb-0">
                <v-select v-model="tempoSegundos"
                  v-if="selectedTipoTreino != null &&  (selectedTipoTreino.nome == 'Potência' || selectedTipoTreino.nome == 'Frequência')"
                  :items="repeticoes240List" outlined dense label="Seg"></v-select>
              </v-col>

              <v-col cols="12" class="pt-0 pb-2">
                <v-divider></v-divider>
              </v-col>

              <v-col cols="12">
                <v-text-field v-model="tempo"
                  v-if="selectedTipoTreino != null &&  selectedTipoTreino.nome != 'Pace'&& selectedTipoTreino.nome != 'Potência' && selectedTipoTreino.nome != 'Frequência'"
                  prepend-icon="mdi-timer-outline" label="Tempo" suffix="min" outlined type="numeric" v-mask="'###'"
                  dense></v-text-field>

                <!-- aqui precisamos testar para o caso da natacao exibirmos 'min/100m' -->
                <v-text-field v-model="volumeSerie"
                  v-if="selectedTipoTreino != null && selectedTipoTreino.nome != 'Pace'"
                  :prepend-icon="selectedTipoTreino.icon" :label="selectedTipoTreino.nome"
                  :suffix="selectedTipoTreino.suffix" type="numeric" v-mask="'###'" outlined dense></v-text-field>
                <v-text-field v-model="calculatedPace"
                  v-if="selectedTipoTreino != null && selectedTipoTreino.nome == 'Pace'"
                  :prepend-icon="selectedTipoTreino.icon" :label="selectedTipoTreino.nome"
                  :suffix="selectedEsporte.medida" outlined dense readonly></v-text-field>

                <v-select v-model="descanso" v-if="selectedTipoTreino != null" :items="repeticoesDescansoList"
                  prepend-icon="mdi-timer-outline" label="Descanso" clearable outlined dense
                  suffix="segundos"></v-select>
                <v-select v-model="repeticoes" v-if="selectedTipoTreino != null" :items="repeticoesList"
                  prepend-icon="mdi-repeat" outlined dense label="Repetições"></v-select>
              </v-col>
              <v-col cols="12" v-if="selectedTipoTreino != null">
                <v-textarea v-model="observacoesSerie" class="caption" outlined max="200" rows="3" counter auto-grow
                  name="observacoesSerie" label="Observações (máx 200)" dense value></v-textarea>
              </v-col>

            </v-row>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-btn color="primary" width="100%" dark primary class="mr-2 mb-2 mt-n3" v-if="selectedTipoTreino != null"
              @click="incluirSerie()">
              Incluir
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-card-actions>

        </v-card>
      </v-dialog>
    </div>

    <!-- dialog com opções de repetição -->
    <div class="text-center">
      <v-dialog v-model="dialogRepeat" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>Repetir este treino</v-card-title>

          <v-card-text class="mt-4">
            <v-row class="pl-3">
              <v-radio-group v-model="radiosRepetir">
                <v-radio label="Dias úteis" value="1"></v-radio>
                <v-radio label="Seg, qua, sex" value="2"></v-radio>
                <v-radio label="Terça e quinta" value="3"></v-radio>
                <v-radio label="Ter, qui e sábado" value="4"></v-radio>
                <v-radio label="Todo sábado" value="5"></v-radio>
                <v-radio label="Todo domingo" value="6"></v-radio>
              </v-radio-group>
            </v-row>
            <v-divider></v-divider>
            <v-row class="pl-3 pr-3">
              <v-menu class="" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field class="mt-5" v-model="computedDateLimiteFormatted" label="Repetir até a data"
                    persistent-hint prepend-icon="mdi-calendar-month-outline" readonly outlined dense v-bind="attrs"
                    v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="dateLimite" no-title @input="menu1 = false" :min="dateTreino"
                  color="primary"></v-date-picker>
              </v-menu>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-btn color="primary" text @click="radiosRepetir = null; dialogRepeat = false">Cancelar</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialogRepeat = false">Ok</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>


    <!-- snackbar com os resultados -->
    <v-snackbar v-model="snackbar" :timeout="snackDelay" :top="true" shaped>
      <v-row class="justify-center">
        {{ snackText }}
      </v-row>

    </v-snackbar>

    <!-- loader -->
    <div class="text-center">
      <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text class="pt-5">
            Ajustando a planilha, aguarde...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

    <div class="text-center">
      <v-dialog v-model="dialogLoader2" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text class="pt-5">
            Carregando os dados...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

  </v-container>
</template>

<script>
import CardTreino from '../../components/CardTreino.vue';
import TreinoTextField from '../../components/TreinoTextField.vue';
//import Atletas from "../../fake-data/Alunos";
import Esportes from "../../fake-data/Esportes";
import TreinoData from "../../fake-data/TreinoData";
import HOST from '../../ws';
import {myMixin} from '../../mixin'

export default {


  components : {
    TreinoTextField,
    CardTreino,
  },
  
  props: {
    source: String
  },

  mixins : [
    myMixin
  ],

  data: vm => ({

    myHost : HOST.HOST,

    dialogLoader: false,
    dialogLoader2: false,

    snackbar : false,
    snackText : '',
    snackDelay : 4000,

    //objetos do datepicker data do treino:
    dateTreino: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu1: false,
    menu2: false,
    today : new Date().toISOString().substr(0, 10),

    //objetos do datepicker de repetição:
    dateLimite: new Date().toISOString().substr(0, 10),

    //objetos dos campos do formulário de passar treino:
    tempo : null,
    tempoSegundos : null,

    //dialog de inserir serie:
    dialogSerie : false,
    descanso : '',
    observacoesSerie : '',
    seriesDoTreino : [],

    //dialogs de detalhe:
    dialog: false,
    dialogComment: false,
    dialogRepeat: false,
    panelStatus: 1,
    loadedComment: "",
    volumeSerie : null,

    //dados do prototipo:
    alunoList: [],
    esportesList: Esportes.ESPORTES,
    tipoTreinoList: TreinoData.TREINODATA,

    selectedAluno: [],
    selectedAlunoTreinosFeitos : [],
    selectedEsporte: null,
    setDefaultEsporte: false,
    selectedTipoTreino: null,
    radiosRepetir : null,

    repeticoes : 1,
    repeticoesList : [],
    repeticoes100List : [],
    repeticoes240List : [],
    repeticoesDescansoList : [],
    repeticoes900List : [],
    frequencia : 10,
    frequenciaList : [],
    metrosNatacaoList : [],
    metrosNatacao : 100,

    //para calculo do pace:
    paceMinutos : null,
    paceSegundos : null,
    paceKilometros : null,
    paceMetros : null,
    calculatedPace : null,
    distanciaKm : null,

    //repeticoes:
    repetir : null,
    repetirData : null,

    finishedLoad : false,


  }),
  created (){
    //adicionando itens ao array da combo:
    var i; 
    for (i = 0; i <= 60; i++) {
      this.repeticoesList.push(i);
    }
    for (i = 0; i <= 100; i++) {
      this.repeticoes100List.push(i);
    }
    for (i = 0; i <= 240; i++) {
      this.repeticoes240List.push(i);
    }
    for (i = 0; i <= 900; i+=10) {
      this.repeticoes900List.push(i);
    }
    for (i = 1; i <= 10; i++) {
      this.frequenciaList.push(i*5);
    }
    for (i = 1; i <= 20; i++) {
      this.metrosNatacaoList.push(i*5);
    }
    for (i = 1; i <= 120; i++) {
      this.metrosNatacaoList.push(i*50);
    }
    for (i = 1; i <= 60; i++) {
      this.repeticoesDescansoList.push(i*5);
    }
    
  },
  beforeMount (){
    this.finishedLoad = false;
    this.reloadAlunoList();
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.dateTreino)
    },
    computedDateLimiteFormatted () {
      return this.formatDate(this.dateLimite)
    },
  },
  watch: {
    dateTreino () {
      this.dateFormatted = this.formatDate(this.dateTreino)
    },
    dateLimite () {
      this.dateLimiteFormatted = this.formatDate(this.dateLimite)
    },
    selectedTipoTreino(){
      this.paceMinutos = null;
      this.paceSegundos = null,
      this.paceKilometros = null;
      this.paceMetros = null,
      this.metrosNatacao = null;
      this.tempo = null;
      this.tempoSegundos = null,
      this.descanso = null;
      this.repeticoes = null;
      this.observacoesSerie = null;
      this.volumeSerie = null;
      this.calculatedPace = null;
    },
    selectedEsporte(){
      this.selectedTipoTreino = null;
      this.radiosRepetir = null;
    }
  },
  methods: {
    reloadAlunoList(){

      this.dialogLoader2 = true;
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      this.axios
      .post(this.myHost + '/user/meusalunos', {}, config)
      .then(response => {
        this.alunoList = response.data;
        this.dialogLoader2 = false;
        this.finishedLoad = true;
      })
      .catch((error) => {
         console.log(error.message);
         this.dialogLoader2 = false;
         this.$store.commit('logout');
         this.$router.push("login");
      });
    },
    openAlunoDetalhe(val) {
      this.selectedAluno = val;
      this.selectedAlunoTreinosFeitos = null;

      //carrega os treinos passados do aluno:
      //carrega os treinos:
      this.dialogLoader2 = true;
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      this.axios
      .post(this.myHost + "/treino/meusultimostreinos/" + this.selectedAluno.id, {}, config)
      .then(response => {
        this.selectedAlunoTreinosFeitos = response.data;
        //console.log(this.treinoList);
        this.dialogLoader2 = false;
      })
      .catch(error => {
        console.log(error.message);
        this.dialogLoader2 = false;
        this.$store.commit("logout");
        this.$router.push("/");
      });

      this.dialog = true;
    },
    openComment(val) {
      this.loadedComment = val;
      this.dialogComment = true;
    },

    //métodos do date picker:
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    calculatePace(){
    //   paceMinutos : null,
    // paceKilometros : null,
    // calculatedPace : null,
    // metrosNatacao : 100,

      if(this.selectedTipoTreino != null &&  this.selectedTipoTreino.nome == 'Pace'){
        if((this.paceMinutos != null && this.paceMinutos != '') || (this.paceSegundos != null && this.paceSegundos != '')){

          //aqui criamos novas variaveis, com o tempo fracionado:    
          var tempMinutos = (this.paceMinutos != null && this.paceMinutos != '' ? this.paceMinutos : 0);
          var tempSegudos = (this.paceSegundos != null && this.paceSegundos != '' ? this.paceSegundos : 0);
          
          var totalSegundos = 0;
          totalSegundos += (this.paceSegundos && this.paceSegundos != '' ? this.paceSegundos : 0);
          totalSegundos += (this.paceMinutos && this.paceMinutos != '' ? this.paceMinutos*60 : 0);
          //console.log('total segundos : ' + totalSegundos);

          let totalMetros = 0;
          totalMetros += (this.paceKilometros && this.paceKilometros != '' ? this.paceKilometros*1000 : 0);
          totalMetros += (this.paceMetros && this.paceMetros != '' ? this.paceMetros : 0);
          //console.log('total metros : ' + totalMetros);

          if(totalSegundos && totalMetros){
            // console.log('total km: ' + totalMetros/1000);
            // console.log('total min: ' + (totalSegundos/60).toFixed(1));
            // console.log('min / km ' + (((totalSegundos/60).toFixed(1)) / (totalMetros/1000)).toFixed(1));
            // console.log('truncated : ' + this.truncator(((totalSegundos/60) / (totalMetros/1000)), 1));

            //aqui o pace, finalmente corrigido:
            //let paceBruto = this.truncator(((totalSegundos/60) / (totalMetros/1000)), 1);
            //console.log('Pace bruto: ' + paceBruto);
            //console.log('Pace liquido: ' + (paceBruto.toFixed(2)));

            // console.log('seg / metros : ' + (totalSegundos/totalMetros).toFixed(3));
            // console.log('metros / seg : ' + (totalMetros/totalSegundos).toFixed(3));
            // console.log('km / h : ' + ((totalMetros/totalSegundos)*3.6).toFixed(3));
            // console.log('min / km : ' + (60/(((totalMetros/totalSegundos)*3.6).toFixed(3))).toFixed(2)); //multiplicamos por 16,667
          }
          
          if(tempSegudos > 0){
            tempMinutos = tempMinutos + eval((tempSegudos/60).toFixed(4));
            //console.log('temp segundos: ' + eval((tempSegudos/60).toFixed(4)));
          }

          if((this.paceKilometros != null && this.paceKilometros != '') || (this.paceMetros != null && this.paceMetros != '')){

            var tempKm = (this.paceKilometros != null && this.paceKilometros != '' ? this.paceKilometros : 0);
            var tempMetros = (this.paceMetros != null && this.paceMetros != '' ? this.paceMetros : 0);
            if(tempMetros > 0){
              tempKm = tempKm + eval((tempMetros/1000).toFixed(4));
            }

            this.distanciaKm = tempKm;
            //let paceBruto = this.truncator(((totalSegundos/60) / (totalMetros/1000)), 4);
            let paceBruto = ((totalSegundos/60) / (totalMetros/1000)).toFixed(2);
            
             switch (this.selectedEsporte.nome){
               case 'Ciclismo' :
                this.calculatedPace = ((tempKm/(tempMinutos/60)).toFixed(2)).replace('.', ':');
                break;
              case 'Corrida' :
                console.log('Pace bruto: ' + paceBruto);
                //console.log('Pace liquido: ' +  60*((paceBruto - Math.trunc(paceBruto))) + (Math.trunc(paceBruto)));
                console.log('lado 1 : ' + (Math.trunc(paceBruto)));
                console.log('lado 2 : ' + (paceBruto - Math.trunc(paceBruto)).toFixed(3));
                console.log('facao minuto : ' +  ((60*(paceBruto - Math.trunc(paceBruto))).toFixed(2)/100));
                //this.calculatedPace = (60*((paceBruto - Math.trunc(paceBruto)).toFixed(1)) + (Math.trunc(paceBruto)));
                this.calculatedPace = this.truncator((((Math.trunc(paceBruto) != 0 ? Math.trunc(paceBruto) : 0) + ((paceBruto - Math.trunc(paceBruto)) != 0 ? (this.truncator((60*(paceBruto - Math.trunc(paceBruto))), 4)/100) : 0))), 2).toString().replace('.', ':');
                if(this.calculatedPace && this.calculatedPace.substring(this.calculatedPace.indexOf(':')).length == 2){
                  this.calculatedPace += '0';
                }
                break;
             }
          } else if(this.metrosNatacao != null && this.metrosNatacao != ''){

             switch (this.selectedEsporte.nome){
              case 'Natação' :
                //console.log('total segundos: ' + (totalSegundos));
                //console.log('pace calculado: ' + (totalSegundos/(this.metrosNatacao/100)));

                var totalSeconds = (totalSegundos/(this.metrosNatacao/100));
                var paceInMinutes = Math.floor((totalSeconds/60).toFixed(2));
                var paceInSeconds = Math.floor(totalSeconds%60);
                //console.log('paceInMinutes: ' + paceInMinutes);
                //console.log('paceInSeconds: ' + paceInSeconds);

                //this.calculatedPace = (tempMinutos/(this.metrosNatacao/100)).toFixed(2);
                this.calculatedPace = this.fillZeros(new String(paceInMinutes)) + ':' + this.fillZeros(new String(paceInSeconds));
                break;
             }
          }
        }
      }
    },

    removerSerie(val) {
      this.seriesDoTreino.splice(val,1);
    },

    removerSeries() {
      this.seriesDoTreino = [];
    },

    incluirSerie(){

      let novaSerie = {
        id : (this.seriesDoTreino.length + 1),
        esporte : this.selectedEsporte.nome,
        tipoTreino : this.selectedTipoTreino.nome,
        paceMinutos : this.paceMinutos,
        paceSegundos : this.paceSegundos,
        metrosNatacao : this.metrosNatacao,
        tempo : this.tempo,
        tempoSegundos : this.tempoSegundos,
        descanso : this.descanso,
        repeticoes : this.repeticoes,
        calculatedPace : this.calculatedPace,
        medida : this.selectedEsporte.medida,
        volume : this.volumeSerie,
        observacoes : this.observacoesSerie,
        distanciaKm : this.distanciaKm,
        ordem : this.seriesDoTreino.length,
      }

      this.seriesDoTreino.push(novaSerie);
      this.dialogSerie = false;
      this.selectedTipoTreino = null;

      //snackbar sucesso:
      this.snackText = 'Série adicionada ao treino.';
      this.snackbar = true;
    },
    salvarTreino(){

      //console.log(JSON.stringify(this.seriesDoTreino));
      this.dialogLoader = true;

      //montando o objeto:
      let newTreino = {
        professor : this.$store.getters.userLogged,
        aluno : this.selectedAluno,
        //dataTreino : this.dateFormatted,
        dataTreino : this.computedDateFormatted,
        dataTreinoAsString : this.computedDateFormatted,
        esporte : this.selectedEsporte.nome,
        series : this.seriesDoTreino,
        repetir : this.radiosRepetir,
        dateLimite : this.computedDateLimiteFormatted,
      }
      //console.log(JSON.stringify(newTreino));  
      this.axios({
        method: 'post',
        url : this.myHost + '/treino/save', 
        headers: {
            'Content-Type' : 'application/json',
            Authorization: `Bearer ${this.$store.state.currentToken}`},
            data : JSON.stringify(newTreino)
      }).then((response) => {

        console.log('treino salvo : ' + response.status);  
        this.dialogLoader = false;
        this.selectedEsporte = null;
        this.snackText = 'Treino agendado para o aluno!';
        this.snackbar = true;
        this.seriesDoTreino = [];
        
      });
    },
    clickTrash(treino){
      this.dialogLoader = true;
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      this.axios
        .post(this.myHost + "/treino/deletetreino/" + treino.id, {}, config)
        .then(response => {
          console.log('click trash : ' + response.status);  

          //carrega os treinos passados do aluno:
          //carrega os treinos:
          const config = {
            headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
          };
          this.axios
          .post(this.myHost + "/treino/meusultimostreinos/" + this.selectedAluno.id, {}, config)
          .then(response => {
            this.selectedAlunoTreinosFeitos = response.data;
            this.dialogLoader = false;
            //console.log(this.treinoList);
          })
          .catch(error => {
            console.log(error.message);
            this.dialogLoader = false;
            this.$store.commit("logout");
            this.$router.push("/");
          });
      })
      .catch(error => {
        console.log(error.message);
        this.dialogLoader = false;
        this.$store.commit("logout");
        this.$router.push("/");
       });
    },
    
  },
  
};
</script>